// src/Context/streakEvents.ts
// The bridge from the activity API wrappers (review, Verb Lab, frames,
// missions, boss, lesson unit end) to StreakContext: each completion response
// carries a `streak` object; reporting it lets the provider celebrate the first
// activity of the day wherever it ended, without threading context through.
export const STREAK_EVENT = "moonrock:streak";

export function reportStreak(streak: unknown): void {
  if (!streak || typeof streak !== "object") return;
  window.dispatchEvent(new CustomEvent(STREAK_EVENT, { detail: streak }));
}
